module.exports = __webpack_public_path__ + "img/2-01-04-adp-excellence.bae69558.svg";